
export const amdComp = [1, 2, 3, 4, 7, 8, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20 ,21]

export const intelComp = [1, 2, 5, 6, 7, 8, 9 ,10 , 11, 12, 13, 14, 15, 16, 17, 18, 19, 20 ,21]